var waitFor = require("../utils/waitFor");
var posiSession = require("../utils/posi-session");

function isRohs(partNumber) {
  return (
    partNumber.indexOf("/AA") > -1 ||
    partNumber.indexOf("-AA") > -1 ||
    partNumber.indexOf("EC") === 0 ||
    partNumber.indexOf("PA") === 0
  );
}

waitFor("#qpl-search-results-table", function () {
  var dt = require("datatables.net")(window, jQuery),
    dt_fixedheader = require("datatables.net-fixedheader")(window, jQuery),
    dtUtils = require("../utils/dtUtils"),
    posiLogger = require("../utils/event-logger.js")(),
    $searchResultsTable = $("#qpl-search-results-table");

  // Results table
  var colData = [
    {
      title: "Government Designation",
      func: function (data) {
        return '<span class="part-number">' + data.military_num + "</span>";
      },
      className: "col-emphasize",
      width: "250px",
    },
    {
      title: "Manufacturer’s Designation (For Reference Only)",
      func: function (data) {
        return '<span class="part-number">' + data.reference_num + "</span>";
      },
      className: "col-emphasize",
      width: "250px",
    },
    {
      title: "Category",
      func: function (data) {
        return data.category;
      },
    },
    {
      title: "Footnotes",
      func: function (data) {
        if (!data.notes || data.notes.length === 0) return "";
        return (
          '<span class="view-tooltip table-only">View Notes <span class="picker-tooltip" role="tooltip">' +
          data.notes.replace("\r\n", "<br>") +
          "</span></span>" +
          '<span class="card-only">NOTE: ' +
          data.notes.replace("\r\n", "<br>") +
          "</span>"
        );
      },
      noSort: true,
    },
    {
      title: "2D Drawing",
      func: function (data) {
        if (data.drawing && data.drawing.hasPDF)
          return (
            '<a href="#" data-part="' +
            data.drawing.partNumber +
            '" class="pdf download-2d">Download</a>' +
            (data.drawing.pdfRevision
              ? '<span class="pdf-revision">Rev ' +
                data.drawing.pdfRevision +
                "</span>"
              : "")
          );

        return (
          '<a class="request-drawing request-2d" data-part="' +
          data.military_num +
          '" href="#">Request<span class="card-only">&nbsp;2D Drawing</span></a>'
        );
      },
      noSort: true,
    },
    {
      title: "3D Drawing",
      func: function (data) {
        var stepPartNumber = false;

        if (data.drawing) {
          if (data.drawing.hasStep || data.drawing.onTP) {
            stepPartNumber = data.drawing.partNumber;
          } else if (data.drawing.matchHasStep || data.drawing.matchHasTP) {
            if (isRohs(data.drawing.partNumber))
              stepPartNumber = data.drawing.partNumber.substring(
                0,
                data.drawing.partNumber.length - 3
              );
            else stepPartNumber = data.drawing.partNumber + "/AA"; // TODO: accommodate "-AA" too
          }

          if (data.drawing.onTP || data.drawing.matchHasTP)
            return (
              '<a href="#" data-part="' +
              stepPartNumber +
              '" class="traceparts-preview button button--blue-light button--small">View/Download<span class="card-only">&nbsp;3D</span></a>'
            );

          if (stepPartNumber)
            return (
              '<a href="#" data-part="' +
              stepPartNumber +
              '" class="download-3d stp">Download</a>'
            );
        }

        return (
          '<a class="request-drawing request-3d" data-part="' +
          data.partNumber +
          '" href="#">Request<span class="card-only">&nbsp;3D Drawing</span></a>'
        );
      },
      noSort: true,
    },
  ];

  // process results for columns
  $searchResultsTable.DataTable({
    data: dtUtils.formatResultsData(window.qplSearchResults, colData),
    columns: dtUtils.buildDataTablesColumns(colData),
    fixedHeader: false,
    searching: false,
    lengthChange: false,
    // autoWidth: false,
    info: false,
    dom: '<"dataTables-top-pagination"p>t<"dataTables-bottom-pagination"p>',
  });

  // scroll to top on page change
  $searchResultsTable.on("page.dt", function () {
    $("html, body").animate(
      {
        scrollTop: $("#qpl-search-results-table").offset().top - 40,
      },
      300
    );
  });
});
